const yup = require("yup");

const addFunding = yup.object().shape({
  fromAccount: yup.string().required("Select a funding account"),
  toAccount: yup.string().required("Select a destination account"),
  amount: yup
    .number()
    .positive("Amount must be positive")
    .required("Amount is required")
    .test("is-decimal", "Amount can have at most 2 decimal places", (value) =>
      value ? /^\d+(\.\d{1,2})?$/.test(value) : true,
    ),
  confirmTransfer: yup.boolean(),
  memo: yup.string(),
});

export default addFunding;
